/* eslint-disable @typescript-eslint/no-explicit-any */
export default function DocLink(props: { link: any; children: any }) {
  return (
    <a href={props.link} target='_blank'>
      <span className='text-blue-600 hover:text-blue-700 pl-1 py-2 sm:py-4 text-base lg:text-lg font-bold tracking-wider'>
        {props.children}
      </span>
    </a>
  )
}
